import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource, MatDialog, MatDialogConfig, PageEvent } from '@angular/material';
import { Subject } from 'rxjs';
import 'jspdf-autotable';
import { CustomDateComponent } from './customdate/custom-date.component';
import * as moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import * as _ from "lodash";
import { RenewalWindowComponent } from '../renewal-window/renewal-window.component';
import { saveAs } from 'file-saver';
import Swal from 'sweetalert2';
//import * as XLSX from 'xlsx';
import * as XLSX from 'xlsx-js-style';
import { debounceTime } from 'rxjs/operators';
import * as FileSaver from 'file-saver';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
var ReportComponent = /** @class */ (function () {
    function ReportComponent(router, toastr, reportService, matDialog, ngxLoader, injectedTransformerId, route, _dashboardService, transMngSer) {
        this.router = router;
        this.toastr = toastr;
        this.reportService = reportService;
        this.matDialog = matDialog;
        this.ngxLoader = ngxLoader;
        this.injectedTransformerId = injectedTransformerId;
        this.route = route;
        this._dashboardService = _dashboardService;
        this.transMngSer = transMngSer;
        this.thresholdInputSubject = new Subject();
        this.commonColumns = ["Transformer Id", "Deviceid", "DATE", "Time"];
        this.isUploading = false;
        this.filter = {};
        this.TapPositionFilter = {};
        this.transformerIds = [];
        this.timeOptions = ['Today', 'Yesterday', 'This Week', 'This Month', 'Last Month', 'Custom'];
        this.parametersOption = ['All', 'Physical Parameters', "Electrical Parameters"];
        this.reportData = [];
        this.electricalParams = [];
        this.allParameters = [];
        this.TapPositionData = [];
        this.windingtemprature = [];
        this.isDownloading = false;
        this.historyData = [];
        this.currentUserData = JSON.parse(localStorage.getItem('userData'));
        this.totalRecords = 0;
        this.pageIndex = 0;
        this.pageSize = 5;
        this.lastRecordId = 0;
        this.pageIndexNextCompare = 0;
        this.isPageDownload = true;
        this.remainingTime = 0;
        this.filterColumns = [];
        this.downloadMessage = 'Downloading...';
        this.thresholdInputValue = '';
        this.selectedParameterStatus = '';
        this.parameterList = [];
        this.isTapPosition = false;
        this.tapCounter = 0;
    }
    ReportComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b;
            var _this = this;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!this.route.snapshot.queryParams['transformerId']) return [3 /*break*/, 2];
                        this.transformerParam = this.route.snapshot.queryParams['transformerId'];
                        this.ngxLoader.start();
                        _a = this;
                        return [4 /*yield*/, this.getDdlData()];
                    case 1:
                        _a.transformerIds = _c.sent();
                        this.transformerIds.push("All");
                        if (this.transformerIds.length > 0) {
                            this.idFilter = this.transformerParam;
                            this.timeFilter = 'Today';
                            this.filter.transformerId = _.cloneDeep(this.transformerParam).split('[')[0];
                            this.filters('date', 'Today');
                        }
                        else {
                            this.ngxLoader.stop();
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        this.ngxLoader.start();
                        this.thresholdInputSubject
                            .pipe(debounceTime(2000)) // 1000 ms = 1 second delay
                            .subscribe(function () {
                            _this.applyParameterAndThresholdFilter();
                        });
                        _b = this;
                        return [4 /*yield*/, this.getDdlData()];
                    case 3:
                        _b.transformerIds = _c.sent();
                        console.log("what Data Is This", this.transformerIds.length);
                        if (this.transformerIds.length > 0) {
                            if (this.injectedTransformerId != undefined) {
                                this.transformerParam = this.injectedTransformerId;
                            }
                            else {
                                this.transformerParam = this.transformerIds[0];
                                this.idFilter = this.transformerParam;
                            }
                            this.filter.transformerId = _.cloneDeep(this.transformerParam).split('[')[0];
                            this.getDropdownPeramter(this.filter.transformerId);
                            // var todayFilter: any = {};
                            // todayFilter = await this.filters('date', 'Today');
                            // console.log('TODAY FILTER:', todayFilter);
                            // this.filter = {...this.filter, ...todayFilter};
                            this.timeFilter = 'Today';
                            this.filters('date', 'Today');
                        }
                        else {
                            console.log("NO DATA");
                            this.ngxLoader.stop();
                            this.router.navigate(['/dashboard']);
                        }
                        _c.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ReportComponent.prototype.applyParameterAndThresholdFilter = function () {
        // If no selection is made (user wants to reset/clear the filter)
        if (!this.selectedParameterStatus || !this.thresholdInputValue) {
            delete this.filter.parameterName;
            delete this.filter.thresholdValue;
            this.fetchReportData(this.filter);
            return;
        }
        this.filter.parameterName = this.selectedParameterStatus.display;
        if (this.filter.parameterName === 'Oil_Level') {
            var levelMap = {
                low: 4,
                medium: 5,
                high: 6
            };
            var input = this.thresholdInputValue.toString().toLowerCase();
            if (levelMap[input] !== undefined) {
                this.filter.thresholdValue = levelMap[input];
            }
            else if (['4', '5', '6'].includes(input)) {
                this.filter.thresholdValue = parseInt(input, 10);
            }
            else {
                this.filter.thresholdValue = 5; // default to medium
            }
        }
        else {
            this.filter.thresholdValue = this.thresholdInputValue;
        }
        this.fetchReportData(this.filter);
    };
    ReportComponent.prototype.onThresholdInputChange = function () {
        this.thresholdInputSubject.next();
    };
    ReportComponent.prototype.getDdlData = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var userData = JSON.parse(localStorage.getItem('userData'));
            _this.transMngSer.getTransformerData(userData.roleid, userData.userid, 'x``z')
                .toPromise()
                .then(function (response) {
                console.log("see filter", response);
                if (response.data && response.data.length > 0) {
                    if (_this.currentUserData.roleid !== 1) {
                        var activeDevices = response.data.filter(function (a) { return a.amc_status === "Active"; });
                        _this.allDeviceDataForFilter = activeDevices;
                        resolve(activeDevices.map(function (a) { return a.serialnumber + "[" + a.sitename + "]"; }));
                    }
                    else {
                        _this.allDeviceDataForFilter = response.data;
                        resolve(response.data.map(function (a) { return a.serialnumber + "[" + a.sitename + "]"; }));
                    }
                }
                else {
                    resolve([]);
                }
            })
                .catch(function (err) {
                console.error("Error in getDdlData:", err);
                reject(err);
            });
        });
    };
    ReportComponent.prototype.getDropdownPeramter = function (transformerselected) {
        var _this = this;
        var Transformerid = transformerselected.split('[')[0].trim();
        console.log(Transformerid, 'clean transformer id');
        this.reportService.getParametersByTransformerId(Transformerid).subscribe(function (res) {
            var unwanted = [
                'apPRVStatus',
                'apOSRStatus',
                'apBuchholzStatus',
                'apOTIStatus',
                'apWTIStatus',
                'apVunbalance',
                'apIunbalance',
                'apCriticalload'
            ];
            _this.parameterList = res
                .filter(function (item) { return !unwanted.includes(item.parameterName); })
                .map(function (item) {
                return {
                    original: item.parameterName,
                    display: _this.formatParameterName(item.parameterName),
                    internal: _this.getInternalParam(item.parameterName)
                };
            });
            console.log('Filtered & Formatted Parameters:', _this.parameterList);
        }, function (error) {
            console.error('API Error:', error);
        });
    };
    ReportComponent.prototype.getInternalParam = function (param) {
        var internalMap = {
            'apOverload': 'Overload',
            'apUnderload': 'Underload',
            'apHighvolt': 'High Volt',
            'apLowvolt': 'Low Volt',
            'apOiltemperature': 'Oil Temperature',
            'apWindingtemperature': 'Winding Temperature',
            'apVunbalance': 'V Unbalance',
            'apIunbalance': 'I Unbalance',
            'apLowPowerfactor': 'Low Power Factor',
            'apOillevel': 'Oil Level'
        };
        return internalMap[param] || param;
    };
    ReportComponent.prototype.formatParameterName = function (param) {
        var customMap = {
            'apOverload': 'avgCurrent',
            'apUnderload': 'lowavgCurrent',
            'apHighvolt': 'Average_Voltage',
            'apLowvolt': 'lowAverage_Voltage',
            'apOiltemperature': 'Oil_Temperature',
            'apWindingtemperature': 'Winding_Temperature',
            'apVunbalance': 'vUnbalance',
            'apIunbalance': 'iUnbalance',
            'apLowPowerfactor': 'Avg_Power_Factor',
            'apOillevel': 'Oil_Level'
        };
        // If exact match exists in the map, return the mapped value
        if (customMap[param]) {
            return customMap[param];
        }
        // Default formatting logic
        if (param.startsWith('ap')) {
            param = param.substring(2);
        }
        var result = param.replace(/([A-Z])/g, ' $1');
        return result.charAt(0).toUpperCase() + result.slice(1);
    };
    ReportComponent.prototype.filters = function (type, param) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var filter, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (type === 'transformerId') {
                            this.getDropdownPeramter(param);
                            this.selectedParameterStatus = '';
                            this.thresholdInputValue = '';
                            delete this.filter.parameterName;
                            delete this.filter.thresholdValue;
                        }
                        this.totalRecords = 0;
                        this.pageIndex = 0;
                        this.pageSize = 5;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        console.log(type, param);
                        if (!(type === 'transformerId')) return [3 /*break*/, 2];
                        this.idFilter = param;
                        // this.filter = ;
                        //this.filter.transformerId = param
                        this.transformerParam = param;
                        if (param == "All") {
                            this.filter.transformerId = this.currentUserData.userid;
                        }
                        else {
                            this.filter.transformerId = _.cloneDeep(this.transformerParam).split('[')[0];
                        }
                        this.fetchReportData(this.filter);
                        return [3 /*break*/, 5];
                    case 2:
                        if (!(type === 'date')) return [3 /*break*/, 4];
                        this.timeFilter = param;
                        return [4 /*yield*/, this.formatDate(param)];
                    case 3:
                        filter = _a.sent();
                        //this.filter = this.filter + filter;
                        if (filter.filter === 'This Week' || filter.filter === 'This Month' || filter.filter === 'Last Month') {
                            if (this.filter && this.filter.date) {
                                delete this.filter.date;
                            }
                            this.filter.startDate = filter.startDate;
                            this.filter.endDate = filter.endDate;
                            this.filter.filter = filter.filter;
                        }
                        else if (filter.filter === 'Today' || filter.filter === 'Yesterday') {
                            if (this.filter && this.filter.startDate && this.filter.endDate) {
                                delete this.filter.startDate;
                                delete this.filter.endDate;
                            }
                            this.filter.filter = filter.filter;
                            this.filter.date = filter.date;
                            this.fetchReportData(this.filter);
                        }
                        else if (filter.filter === 'Custom') {
                            if (this.filter && this.filter.date) {
                                delete this.filter.date;
                            }
                            if (filter.startDate && filter.endDate) {
                                this.filter.startDate = filter.startDate;
                                this.filter.endDate = filter.endDate;
                                this.filter.filter = filter.filter;
                            }
                        }
                        if (filter.startDate && filter.endDate) {
                            this.fetchReportData(this.filter);
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        if (type === 'parameters') {
                            this.paramFilter = param;
                            if (param === 'Physical Parameters') {
                                this.typeFilter = type;
                                this.reportColumns = this.physicalParams;
                                this.filterColumns = this.physicalParams;
                                // this.dataSource = new MatTableDataSource(this.data);;
                                // this.dataSource.paginator = this.paginator;
                                // this.dataSource.sort = this.sort;
                            }
                            else if (param === 'All') {
                                this.reportColumns = this.allParameters;
                                this.filterColumns = this.allParameters;
                            }
                            else if (param === 'Electrical Parameters') {
                                this.reportColumns = this.electricalParams;
                                this.filterColumns = this.electricalParams;
                            }
                            else if (param === 'HT Parameters') {
                                this.reportColumns = this.HTParameters;
                                this.filterColumns = this.HTParameters;
                            }
                            else {
                                this.reportColumns = this.allParameters;
                                this.filterColumns = this.reportColumns;
                            }
                        }
                        _a.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        error_1 = _a.sent();
                        console.log('ERROR:', error_1);
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    ReportComponent.prototype.formatDate = function (param) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (param === 'Today') {
                var d = new Date(), month = '' + (d.getMonth() + 1), day = '' + d.getDate(), year = d.getFullYear();
                if (month.length < 2)
                    month = '0' + month;
                if (day.length < 2)
                    day = '0' + day;
                resolve({ 'date': [year, month, day].join('-'), 'filter': param });
                // return [year, month, day].join('-');
            }
            else if (param === 'Yesterday') {
                var date = new Date();
                date.setDate(date.getDate() - 1); // Subtract one day from the current date
                var year_1 = date.getFullYear();
                var month_1 = ('0' + (date.getMonth() + 1)).slice(-2); // Add leading zero if needed
                var day_1 = ('0' + date.getDate()).slice(-2); // Add leading zero if needed
                var yesterday = year_1 + "-" + month_1 + "-" + day_1;
                resolve({ 'date': yesterday, 'filter': param });
                //return [year, month, day].join('-');
            }
            else if (param === 'Last Month') {
                resolve({ 'startDate': moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'), 'endDate': moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD'), 'filter': param });
                // resolve('&' + `startDate=${[year, month, day].join('-')}` + '&' + `endDate=${[year, month, 30].join('-')}` +  '&' + `filter=${param}`);
                // resolve({'startDate':[year, month, day].join('-'), 'endDate':[year, month, 30].join('-')});
            }
            else if (param === 'This Month') {
                resolve({ 'startDate': moment().startOf('month').format('YYYY-MM-DD'), 'endDate': moment().endOf('month').format('YYYY-MM-DD'), 'filter': param });
                // resolve('&' + `startDate=${[year, month, day].join('-')}` + '&' + `endDate=${[year, month, 30].join('-')}` +  '&' + `filter=${param}`);
            }
            else if (param === 'This Week') {
                resolve({ 'startDate': moment().startOf('week').format('YYYY-MM-DD'), 'endDate': moment().endOf('week').format('YYYY-MM-DD'), 'filter': param });
                //  resolve('&' + `startDate=${[year, month, startDate].join('-')}` + '&' + `endDate=${[year, month, day].join('-')}` +  '&' + `filter=${param}`);
            }
            else if (param === 'Custom') {
                var dialogConfig = new MatDialogConfig();
                var dialogRef = _this.matDialog.open(CustomDateComponent, {
                    autoFocus: false,
                    height: '350px', width: '450px', data: { "details": "", "action": "Add", selectedDate: _this.customeSelectedDate }
                });
                dialogRef.afterClosed().subscribe(function (value) {
                    console.log("Value=======", value);
                    _this.customeSelectedDate = value;
                    resolve({ 'startDate': value.startDate, 'endDate': value.endDate, 'filter': param });
                });
            }
        });
    };
    ReportComponent.prototype.exportToPdf = function (data, fileName) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var pdfData, docDefinition, error_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.formatData(data)];
                    case 1:
                        pdfData = _a.sent();
                        docDefinition = {
                            info: {
                                title: 'Transformer Report',
                            },
                            pageOrientation: 'landscape',
                            pageSize: '4A0',
                            content: [
                                {
                                    text: '⚡Transformer Performance Report ⚙️',
                                    style: 'header',
                                    alignment: 'center',
                                    margin: [0, 0, 0, 30],
                                    color: '#2E86C1'
                                },
                                {
                                    stack: [
                                        { text: 'Generated On: ' + new Date().toLocaleDateString(), style: 'subheader' },
                                        { text: 'Location:' + this.transformerParam, style: 'subheader' }
                                    ],
                                    alignment: 'left',
                                    margin: [0, 0, 0, 20]
                                },
                                {
                                    text: 'Below is the detailed transformer report with all recorded parameters.',
                                    style: 'intro',
                                    margin: [0, 0, 0, 20]
                                },
                                {
                                    table: {
                                        headerRows: 1,
                                        widths: Array(pdfData[0].length).fill('*'),
                                        body: pdfData,
                                    },
                                    layout: {
                                        fillColor: function (rowIndex, node, columnIndex) {
                                            return rowIndex === 0 ? '#D6EAF8' : null;
                                        },
                                        hLineColor: '#AAB7B8',
                                        vLineColor: '#AAB7B8',
                                    }
                                }
                            ],
                            styles: {
                                header: {
                                    fontSize: 28,
                                    bold: true,
                                },
                                subheader: {
                                    fontSize: 16,
                                    italics: true,
                                },
                                intro: {
                                    fontSize: 14,
                                    color: '#34495E'
                                }
                            },
                            defaultStyle: {
                                fontSize: 10
                            }
                        };
                        pdfMake.createPdf(docDefinition).download(fileName + '.pdf');
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        console.log('ERROR:', error_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ReportComponent.prototype.formatData = function (data) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var dataArr = [];
            var elementCols = Object.keys(data[0]);
            var diffCols = elementCols.filter(function (x) { return !_this.filterColumns.includes(x); });
            dataArr.push(_this.filterColumns);
            data.forEach(function (element) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var rowValues;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            delete element['Parameter 2'];
                            delete element['Parameter 3'];
                            delete element['Parameter 4'];
                            delete element['Parameter 5'];
                            delete element['Parameter 6'];
                            delete element['Parameter 7'];
                            delete element['Parameter 8'];
                            delete element['Parameter 9'];
                            delete element['Parameter 10'];
                            return [4 /*yield*/, this.deleteDynamicColumns(element, diffCols)];
                        case 1:
                            element = _a.sent();
                            rowValues = [];
                            this.filterColumns.forEach(function (col) {
                                rowValues.push(element[col]);
                            });
                            console.log('RE ARRANGED COLS:', rowValues);
                            // delete element['Energy_Meter_Temprature'];
                            //  dataArr.push(Object.values(element));
                            dataArr.push(rowValues);
                            return [2 /*return*/];
                    }
                });
            }); });
            var finalArr = dataArr.filter(function (x) { return !Object.keys(x).includes(diffCols.join(",")); });
            resolve(dataArr);
        });
    };
    ReportComponent.prototype.deleteDynamicColumns = function (element, cols) {
        return new Promise(function (resolve, reject) {
            cols.forEach(function (col) {
                delete element[col];
            });
            resolve(element);
        });
    };
    ReportComponent.prototype.fetchReportData = function (filter) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.ngxLoader.start();
                this.transMngSer.getThresholdValue({ transformerid: filter.transformerId }).subscribe(function (response) {
                    if (response.result.length > 0) {
                        _this.thresholdValues = response.result;
                    }
                });
                console.log("Filters Data", filter);
                this.windingtemprature = [];
                this.transMngSer.getTransformerDetails({ transformerId: filter.transformerId, deletedFlag: 'D' }).subscribe(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    var filter_Transformer;
                    var _this = this;
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                this.gradient = response.details.message.description[0]['kwhreading'];
                                this.kvarating = response.details.message.description[0]['ratedLoad'];
                                filter.pageIndex = this.pageIndex;
                                filter.pageSize = this.pageSize;
                                return [4 /*yield*/, this.allDeviceDataForFilter.filter(function (values) { return values.serialnumber == filter.transformerId; })];
                            case 1:
                                filter_Transformer = _a.sent();
                                console.log('Is This DeviceId I want', response.details.message.description);
                                filter.deviceId = filter_Transformer[0].deviceId;
                                filter.lastSeenId = this.lastRecordId;
                                this.reportService.getReportData(filter).toPromise().then(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                    var columnLength, i_1, addition, averageLoad, LoadPercentage, gradientContribution, windingTemprature, element, i_2, parameterlength, i_3;
                                    var _this = this;
                                    return tslib_1.__generator(this, function (_a) {
                                        // this.transformerIds = await this.getDdlData();
                                        this.allParameters = this.commonColumns
                                            .concat(response.physicalParams, response.electricalParam, response.HTParameters);
                                        if (response.HTParameters && response.HTParameters.length > 0) {
                                            if (this.parametersOption.length < 4) {
                                                this.parametersOption.push("HT Parameters");
                                            }
                                        }
                                        else if (this.parametersOption.length > 3) {
                                            this.parametersOption.pop();
                                        }
                                        this.physicalParams = this.commonColumns.concat(response.physicalParams);
                                        this.electricalParams = this.commonColumns.concat(response.electricalParam);
                                        this.HTParameters = this.commonColumns.concat(response.HTParameters);
                                        if (this.paramFilter === 'Physical Parameters') {
                                            this.reportColumns = this.commonColumns.concat(response.physicalParams);
                                            this.filterColumns = this.commonColumns.concat(response.physicalParams);
                                        }
                                        else if (this.paramFilter === 'Electrical Params') {
                                            if (response.electricalParam.length > 0) {
                                                this.reportColumns = this.commonColumns.concat(response.electricalParam);
                                                this.filterColumns = this.commonColumns.concat(response.electricalParam);
                                            }
                                            else {
                                                this.reportColumns = [];
                                                this.filterColumns = [];
                                            }
                                        }
                                        else if (this.paramFilter === 'HT Parameters') {
                                            if (response.electricalParam.length > 0) {
                                                this.reportColumns = this.commonColumns.concat(response.HTParameters);
                                                this.filterColumns = this.commonColumns.concat(response.HTParameters);
                                            }
                                            else {
                                                this.reportColumns = [];
                                                this.filterColumns = [];
                                            }
                                        }
                                        else if (this.paramFilter === 'All') {
                                            this.reportColumns = this.commonColumns.concat(response.physicalParams, response.electricalParam, response.HTParameters);
                                            this.filterColumns = this.commonColumns.concat(response.physicalParams, response.electricalParam, response.HTParameters);
                                        }
                                        else {
                                            if (response && response.physicalParams && response.electricalParam && response.reportData && response.reportData.length > 0) {
                                                this.reportColumns = this.commonColumns.concat(response.physicalParams, response.electricalParam, response.HTParameters);
                                                this.filterColumns = this.commonColumns.concat(response.physicalParams, response.electricalParam, response.HTParameters);
                                            }
                                            else {
                                                this.reportColumns = [];
                                                this.filterColumns = [];
                                            }
                                        }
                                        if (response && response.reportData && response.reportData.length > 0) {
                                            this.lastRecordId = response.reportData[response.reportData.length - 1].Recordid;
                                            this.totalRecords += response.reportData.length + 1;
                                            this.windingtemprature = [];
                                            this.historyData = response.reportData;
                                            this.dataSource = new MatTableDataSource(this.historyData);
                                            this.deviceID = response.reportData[0]['Deviceid'];
                                            columnLength = response.reportData.length;
                                            for (i_1 = 0; i_1 < columnLength; i_1++) {
                                                if (response.reportData[i_1]['Oil_Temperature'] != 0) {
                                                    addition = Number(response.reportData[i_1]['L1']) +
                                                        Number(response.reportData[i_1]['L2']) +
                                                        Number(response.reportData[i_1]['L3']);
                                                    averageLoad = Number((addition / 3).toFixed(2));
                                                    LoadPercentage = Number(((averageLoad / Number(this.kvarating)) * 100).toFixed(2));
                                                    gradientContribution = Number(((this.gradient * LoadPercentage) / 100).toFixed(2));
                                                    windingTemprature = Number((Number(response.reportData[i_1]['Oil_Temperature']) + gradientContribution).toFixed(2));
                                                    this.windingtemprature.push(windingTemprature.toFixed(2));
                                                }
                                                else {
                                                    this.windingtemprature.push(0);
                                                }
                                            }
                                            console.log("Addition", this.gradient);
                                            console.log("Winding Temprature", response.reportData[0]['L1']);
                                            console.log("DATA FOR REPORTS 123", response.reportData[0]['Humidity']);
                                            element = [];
                                            i_2 = 0;
                                            response.reportData.forEach(function (object) {
                                                object.Winding_Temp_By_Cal = _this.windingtemprature[i_2];
                                                i_2++;
                                                if (object.Buchholz_Status == 0) {
                                                    object.Buchholz_Status = "Healthy";
                                                }
                                                if (object.PRV_Status == 0) {
                                                    object.PRV_Status = "Healthy";
                                                }
                                                if (object.OSR_Status == 0) {
                                                    object.OSR_Status = "Healthy";
                                                }
                                                if (object.OTI_Status == 0) {
                                                    object.OTI_Status = "Healthy";
                                                }
                                                if (object.WTI_Status == 0) {
                                                    object.WTI_Status = "Healthy";
                                                }
                                                if (object.MOG_Status == 0) {
                                                    object.MOG_Status = "Healthy";
                                                }
                                                if (object.Aircell_Relay == 0) {
                                                    object.Aircell_Relay = "Healthy";
                                                }
                                                if (object.OTI_Alarm_Status == 0) {
                                                    object.OTI_Alarm_Status = "Healthy";
                                                }
                                                if (object.WTI_Alarm_Status == 0) {
                                                    object.WTI_Alarm_Status = "Healthy";
                                                }
                                                if (object.OTI_Trip_Status == 0) {
                                                    object.OTI_Trip_Status = "Healthy";
                                                }
                                                if (object.WTI_Trip_Status == 0) {
                                                    object.WTI_Trip_Status = "Healthy";
                                                }
                                                if (object.OTI_Alarm_Status == 1) {
                                                    object.OTI_Alarm_Status = "Operated";
                                                }
                                                if (object.WTI_Alarm_Status == 1) {
                                                    object.WTI_Alarm_Status = "Operated";
                                                }
                                                if (object.OTI_Trip_Status == 1) {
                                                    object.OTI_Trip_Status = "Operated";
                                                }
                                                if (object.WTI_Trip_Status == 1) {
                                                    object.WTI_Trip_Status = "Operated";
                                                }
                                                if (object.MOG_Status == 1) {
                                                    object.MOG_Status = "Operated";
                                                }
                                                if (object.Buchholz_Status == 1) {
                                                    object.Buchholz_Status = "Operated";
                                                }
                                                if (object.PRV_Status == 1) {
                                                    object.PRV_Status = "Operated";
                                                }
                                                if (object.OSR_Status == 1) {
                                                    object.OSR_Status = "Operated";
                                                }
                                                if (object.OTI_Status == 1) {
                                                    object.OTI_Status = "Operated";
                                                }
                                                if (object.WTI_Status == 1) {
                                                    object.WTI_Status = "Operated";
                                                }
                                                if (object.Buchholz_Alarm == 0) {
                                                    object.Buchholz_Alarm = "Healthy";
                                                }
                                                if (object.Buchholz_Alarm == 1) {
                                                    object.Buchholz_Alarm = "Operated";
                                                }
                                                if (object.Buchholz_Trip == 0) {
                                                    object.Buchholz_Trip = "Healthy";
                                                }
                                                if (object.Buchholz_Trip == 1) {
                                                    object.Buchholz_Trip = "Operated";
                                                }
                                                if (object.OTI_Alarm == 1) {
                                                    object.OTI_Alarm = "Healthy";
                                                }
                                                if (object.OTI_Alarm == 0) {
                                                    object.OTI_Alarm = "Operated";
                                                }
                                                if (object.OTI_Trip == 1) {
                                                    object.OTI_Trip = "Healthy";
                                                }
                                                if (object.OTI_Trip == 0) {
                                                    object.OTI_Trip = "Operated";
                                                }
                                                if (object.WTI_Alarm == 0) {
                                                    object.WTI_Alarm = "Healthy";
                                                }
                                                if (object.WTI_Alarm == 1) {
                                                    object.WTI_Alarm = "Operated";
                                                }
                                                if (object.WTI_Trip == 0) {
                                                    object.WTI_Trip = "Healthy";
                                                }
                                                if (object.WTI_Trip == 1) {
                                                    object.WTI_Trip = "Operated";
                                                }
                                                if (object.Aircell_Relay == 1) {
                                                    object.Aircell_Relay = "Operated";
                                                }
                                                if (object.Alarm_Status == 1) {
                                                    object.Alarm_Status = "ACTIVE";
                                                }
                                                if (object.Alarm_Status == 0) {
                                                    object.Alarm_Status = "INACTIVE";
                                                }
                                                if (object.Door_Status == 1) {
                                                    object.Door_Status = "Open";
                                                }
                                                if (object.Door_Status == 0) {
                                                    object.Door_Status = "Close";
                                                }
                                            });
                                            this.ngxLoader.stop();
                                            console.log('REPORT DATA:', response.reportData);
                                            this.data = response.reportData;
                                            this.dataSource.paginator = this.paginator;
                                            this.dataSource.sort = this.sort;
                                            parameterlength = response.physicalParams.length;
                                            for (i_3 = 0; i_3 <= parameterlength; i_3++) {
                                                if (response.physicalParams[i_3] == 'Tap_Position') {
                                                    this.isTapPosition = true;
                                                    this.reportService.getTapPosition(filter).toPromise().then(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                                        return tslib_1.__generator(this, function (_a) {
                                                            console.log("What is Tap Position Data", response);
                                                            this.tapCounter = response.result[0].tapPosition;
                                                            return [2 /*return*/];
                                                        });
                                                    }); });
                                                }
                                            }
                                            //Code for Tap_Position Counter by Rakesh Bhamare
                                            /*let datalength = response.reportData.length;
                                                let parameterlength = response.physicalParams.length;
                                                let tap: string[] = [];
                                                for(let i= 0 ; i<= parameterlength ; i++){
                                                    if(response.physicalParams[i] == 'Tap_Position' ){
                                                        for (let j = 1; j <= datalength; j++) {
                                                            if(response.reportData[j-1]['Tap_Position'] != response.reportData[j]['Tap_Position']){
                                                                tap.push(response.reportData[j-1]['Tap_Position']);
                                                                this.counter = tap.length+1;
                                                            } else {
                        
                                                            }
                                                        }
                                                    }  else {
                                                        this.counter = 0;
                                                    }
                                                } //end*/
                                        }
                                        else {
                                            this.totalRecords = 0;
                                            this.dataSource = [];
                                            this.data = [];
                                            this.deviceID = '';
                                            this.ngxLoader.stop();
                                        }
                                        return [2 /*return*/];
                                    });
                                }); });
                                return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    ReportComponent.prototype.nextDataLoad = function (filter) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var filter_Transformer;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        filter.pageIndex = this.pageIndex;
                        filter.pageSize = this.pageSize;
                        console.log("what is Index", this.pageIndex, this.pageSize);
                        console.log("What is Page", this.historyData.length / this.pageSize, this.pageIndexNextCompare);
                        if (!(this.historyData.length / this.pageSize == this.pageIndexNextCompare)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.allDeviceDataForFilter.filter(function (values) { return values.serialnumber == filter.transformerId; })];
                    case 1:
                        filter_Transformer = _a.sent();
                        filter.deviceId = filter_Transformer[0].deviceId;
                        filter.lastSeenId = this.lastRecordId;
                        this.reportService.getReportData(filter).toPromise().then(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var columnLength, i_4, addition, averageLoad, LoadPercentage, gradientContribution, windingTemprature, element, i_5;
                            var _this = this;
                            return tslib_1.__generator(this, function (_a) {
                                // this.transformerIds = await this.getDdlData();
                                this.allParameters = this.commonColumns
                                    .concat(response.physicalParams, response.electricalParam)
                                    .concat((response.HTParameters && response.HTParameters.length > 0)
                                    ? response.HTParameters
                                    : []);
                                if (response.HTParameters && response.HTParameters.length > 0) {
                                    if (this.parametersOption.length < 4) {
                                        this.parametersOption.push("HT Parameters");
                                    }
                                }
                                else if (this.parametersOption.length > 3) {
                                    this.parametersOption.pop();
                                }
                                this.physicalParams = this.commonColumns.concat(response.physicalParams);
                                this.electricalParams = this.commonColumns.concat(response.electricalParam);
                                this.HTParameters = this.commonColumns.concat(response.HTParameters);
                                if (this.paramFilter === 'Physical Parameters') {
                                    this.reportColumns = this.commonColumns.concat(response.physicalParams);
                                    this.filterColumns = this.commonColumns.concat(response.physicalParams);
                                }
                                else if (this.paramFilter === 'Electrical Params') {
                                    if (response.electricalParam.length > 0) {
                                        this.reportColumns = this.commonColumns.concat(response.electricalParam);
                                        this.filterColumns = this.commonColumns.concat(response.electricalParam);
                                    }
                                    else {
                                        this.reportColumns = [];
                                        this.filterColumns = [];
                                    }
                                }
                                else if (this.paramFilter === 'All') {
                                    this.reportColumns = this.commonColumns.concat(response.physicalParams, response.electricalParam);
                                    this.filterColumns = this.commonColumns.concat(response.physicalParams, response.electricalParam);
                                }
                                else {
                                    if (response && response.physicalParams && response.electricalParam && response.reportData && response.reportData.length > 0) {
                                        this.reportColumns = this.commonColumns.concat(response.physicalParams, response.electricalParam);
                                        this.filterColumns = this.commonColumns.concat(response.physicalParams, response.electricalParam);
                                    }
                                    else {
                                        this.reportColumns = [];
                                        this.filterColumns = [];
                                    }
                                }
                                if (response && response.reportData && response.reportData.length > 0) {
                                    this.lastRecordId = response.reportData[response.reportData.length - 1].Recordid;
                                    this.windingtemprature = [];
                                    console.log("sdfsdf", this.pageIndexNextCompare, this.historyData.length / this.pageSize);
                                    this.historyData.push.apply(this.historyData, response.reportData);
                                    this.totalRecords = this.historyData.length + 1;
                                    this.dataSource = new MatTableDataSource(this.historyData);
                                    this.deviceID = response.reportData[0]['Deviceid'];
                                    columnLength = response.reportData.length;
                                    for (i_4 = 0; i_4 < columnLength; i_4++) {
                                        if (response.reportData[i_4]['Oil_Temperature'] != 0) {
                                            addition = Number(response.reportData[i_4]['L1']) +
                                                Number(response.reportData[i_4]['L2']) +
                                                Number(response.reportData[i_4]['L3']);
                                            averageLoad = Number((addition / 3).toFixed(2));
                                            LoadPercentage = Number(((averageLoad / Number(this.kvarating)) * 100).toFixed(2));
                                            gradientContribution = Number(((this.gradient * LoadPercentage) / 100).toFixed(2));
                                            windingTemprature = Number((Number(response.reportData[i_4]['Oil_Temperature']) + gradientContribution).toFixed(2));
                                            this.windingtemprature.push(windingTemprature.toFixed(2));
                                        }
                                        else {
                                            this.windingtemprature.push(0);
                                        }
                                    }
                                    element = [];
                                    i_5 = 0;
                                    response.reportData.forEach(function (object) {
                                        object.Winding_Temp_By_Cal = _this.windingtemprature[i_5];
                                        i_5++;
                                        if (object.Buchholz_Status == 0) {
                                            object.Buchholz_Status = "Healthy";
                                        }
                                        if (object.PRV_Status == 0) {
                                            object.PRV_Status = "Healthy";
                                        }
                                        if (object.OSR_Status == 0) {
                                            object.OSR_Status = "Healthy";
                                        }
                                        if (object.OTI_Status == 0) {
                                            object.OTI_Status = "Healthy";
                                        }
                                        if (object.WTI_Status == 0) {
                                            object.WTI_Status = "Healthy";
                                        }
                                        if (object.MOG_Status == 0) {
                                            object.MOG_Status = "Healthy";
                                        }
                                        if (object.Aircell_Relay == 0) {
                                            object.Aircell_Relay = "Healthy";
                                        }
                                        if (object.MOG_Status == 1) {
                                            object.MOG_Status = "Operated";
                                        }
                                        if (object.Aircell_Relay == 1) {
                                            object.Aircell_Relay = "Operated";
                                        }
                                        if (object.Buchholz_Status == 1) {
                                            object.Buchholz_Status = "Operated";
                                        }
                                        if (object.PRV_Status == 1) {
                                            object.PRV_Status = "Operated";
                                        }
                                        if (object.OSR_Status == 1) {
                                            object.OSR_Status = "Operated";
                                        }
                                        if (object.OTI_Status == 1) {
                                            object.OTI_Status = "Operated";
                                        }
                                        if (object.WTI_Status == 1) {
                                            object.WTI_Status = "Operated";
                                        }
                                        if (object.Buchholz_Alarm == 0) {
                                            object.Buchholz_Alarm = "Healthy";
                                        }
                                        if (object.Buchholz_Alarm == 1) {
                                            object.Buchholz_Alarm = "Operated";
                                        }
                                        if (object.Buchholz_Trip == 0) {
                                            object.Buchholz_Trip = "Healthy";
                                        }
                                        if (object.Buchholz_Trip == 1) {
                                            object.Buchholz_Trip = "Operated";
                                        }
                                        if (object.OTI_Alarm == 1) {
                                            object.OTI_Alarm = "Healthy";
                                        }
                                        if (object.OTI_Alarm == 0) {
                                            object.OTI_Alarm = "Operated";
                                        }
                                        if (object.OTI_Trip == 1) {
                                            object.OTI_Trip = "Healthy";
                                        }
                                        if (object.OTI_Trip == 0) {
                                            object.OTI_Trip = "Operated";
                                        }
                                        if (object.WTI_Alarm == 0) {
                                            object.WTI_Alarm = "Healthy";
                                        }
                                        if (object.WTI_Alarm == 1) {
                                            object.WTI_Alarm = "Operated";
                                        }
                                        if (object.WTI_Trip == 0) {
                                            object.WTI_Trip = "Healthy";
                                        }
                                        if (object.WTI_Trip == 1) {
                                            object.WTI_Trip = "Operated";
                                        }
                                        if (object.Alarm_Status == 1) {
                                            object.Alarm_Status = "ACTIVE";
                                        }
                                        if (object.Alarm_Status == 0) {
                                            object.Alarm_Status = "INACTIVE";
                                        }
                                        if (object.Door_Status == 1) {
                                            object.Door_Status = "Open";
                                        }
                                        if (object.Door_Status == 0) {
                                            object.Door_Status = "Close";
                                        }
                                    });
                                    this.data = response.reportData;
                                    this.dataSource.paginator = this.paginator;
                                    this.dataSource.sort = this.sort;
                                    //Code for Tap_Position Counter by Rakesh Bhamare
                                    /* let datalength = response.reportData.length;
                                         let parameterlength = response.physicalParams.length;
                                         let tap: string[] = [];
                                         for(let i= 0 ; i<= parameterlength ; i++){
                                             if(response.physicalParams[i] == 'Tap_Position' ){
                                                 for (let j = 1; j <= datalength; j++) {
                                                     if(response.reportData[j-1]['Tap_Position'] != response.reportData[j]['Tap_Position']){
                                                         tap.push(response.reportData[j-1]['Tap_Position']);
                                                         this.counter = tap.length+1;
                                                     } else {
                      
                                                     }
                                                 }
                                             }  else {
                                                 this.counter = 0;
                                             }
                                         } //end */
                                }
                                else {
                                    this.totalRecords -= 1;
                                    //this.dataSource = [];
                                    this.data = [];
                                    this.deviceID = '';
                                    this.ngxLoader.stop();
                                }
                                return [2 /*return*/];
                            });
                        }); });
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    ReportComponent.prototype.generateDataArray = function (data) {
        var reportData = [];
        var rowdata;
        return new Promise(function (resolve, reject) {
            data.forEach(function (element) {
                rowdata = Object.values(element);
            });
            resolve(rowdata);
        });
    };
    ReportComponent.prototype.refreshData = function () {
        this.ngOnInit();
    };
    ReportComponent.prototype.getRenewalData = function () {
        var _this = this;
        this._dashboardService.getRenewalDate(this.currentUserData.userid).subscribe(function (response) {
            if (response.result.length > 0) {
                if (response.result[0].RenewalDays >= 365 || response.result[0].dashboardaccess == 0) {
                    var domObject = document.getElementById("denyDashboardAccess");
                    domObject.style.opacity = '0.1';
                    var dialogRef = _this.matDialog.open(RenewalWindowComponent, {
                        autoFocus: false,
                        height: '85%', width: '50%', data: { data: response.result }, disableClose: true, panelClass: 'custom-dialog-container'
                    });
                    dialogRef.afterClosed().subscribe(function (response) {
                    });
                }
            }
        });
    };
    ReportComponent.prototype.getHeaderName = function (col) {
        switch (col) {
            case 'Transformer Id':
                return 'Transformer Id';
            case 'Deviceid':
                return 'Device Id';
            case 'DATE':
                return 'Date';
            case 'Time':
                return 'Time';
            case 'Oil_Temperature':
                return 'Oil Temperature (°C)';
            case 'Oil_Level':
                return 'Oil Level';
            case 'Winding_Temp_By_Cal':
                return 'Winding Temperature (°C)';
            case 'loadPercentage':
                return 'Load (%)';
            case 'Ambient_Temperature':
                if (this.filter.transformerId == "KR236-1350") {
                    return 'Control pannel - Ambient temp';
                }
                else {
                    return 'Ambient Temperature (°C)';
                }
            case 'Humidity':
                if (this.filter.transformerId == "KR236-1350") {
                    return 'Control pannel-Humidity';
                }
                else {
                    return 'Humidity (%)';
                }
            case 'Average_Voltage':
                return 'Average Voltage (V)';
            case 'R_Ph_N':
                return 'R-N Voltage (V)';
            case 'Y_Ph_N':
                return 'Y-N Voltage (V)';
            case 'B_Ph_N':
                return 'B-N Voltage (V)';
            case 'RY_Voltage':
                return 'R-Y Voltage (V)';
            case 'YB_Voltage':
                return 'Y-B Voltage (V)';
            case 'BR_Voltage':
                return 'B-R Voltage (V)';
            case 'L1':
                return 'R - Current (A)';
            case 'L2':
                return 'Y - Current (A)';
            case 'L3':
                return 'B - Current (A)';
            case 'LN':
                return 'N - Current (A)';
            case 'R_Power_Factor':
                return 'R - Power Factor';
            case 'Y_Power_Factor':
                return 'Y - Power Factor';
            case 'B_Power_Factor':
                return 'B - Power Factor';
            case 'Avg_Power_Factor':
                return 'Average Power Factor';
            case 'R_Active_Power':
                return 'R - Active Power (kW)';
            case 'Y_Active_Power':
                return 'Y - Active Power (kW)';
            case 'B_Active_Power':
                return 'B - Active Power (kW)';
            case '3_Phase_Active_Power':
                return '3 Ph Active Power (kW)';
            case 'R_Reactive_Power':
                return 'R - Reactive Power (kvar)';
            case 'Y_Reactive_Power':
                return 'Y - Reactive Power (kvar)';
            case 'B_Reactive_Power':
                return 'B - Reactive Power (kvar)';
            case '3_Phase_Reactive_Power':
                return '3 Ph Reactive Power (kvar)';
            case 'R_apparent_Power':
                return 'R - Apparent Power (kva)';
            case 'Y_apparent_Power':
                return 'Y - Apparent Power (kva)';
            case 'B_apparent_Power':
                return 'B - Apparent Power (kva)';
            case '3_Phase_Apparent_Power':
                return '3 Ph Apparent Power (kva)';
            case 'Frequency':
                return 'Frequency (Hz)';
            case 'VR_THD':
                return 'R - Voltage - THD';
            case 'VY_THD':
                return 'Y - Voltage - THD';
            case 'VB_THD':
                return 'B - Voltage - THD';
            case 'IR_THD':
                return 'R - Current - THD';
            case 'IY_THD':
                return 'Y - Current - THD';
            case 'IB_THD':
                return 'B - Current - THD';
            case 'System_kwh':
                return 'Active(kWh)';
            case 'logSystem_Kwh':
                return 'Active Forwarded (kWh)';
            case 'System_Kvah':
                return 'Apparent Forwarded (kvah)';
            case 'lt1':
                return 'INCOMER CABLE R PHASE';
            case 'lt2':
                return 'INCOMER CABLE Y PHASE';
            case 'lt3':
                return 'INCOMER CABLE B PHASE';
            case 'lt4':
                return 'OUTGOING BUS BAR R PHASE';
            case 'lt5':
                return 'OUTGOING BUS BAR Y PHASE';
            case 'lt6':
                return 'OUTGOING BUS BAR B PHASE';
            case 'lt7':
                return 'OUTGOING BUS BAR RIGHT  R PHASE';
            case 'lt8':
                return 'OUTGOING BUS BAR RIGHT  Y PHASE';
            case 'lt9':
                return 'OUTGOING BUS BAR RIGHT  B PHASE';
            case 'lt10':
                return 'OUTGOING BUS BAR LEFT R PHASE';
            case 'lt11':
                return 'OUTGOING BUS BAR LEFT Y PHASE';
            case 'lt12':
                return 'OUTGOING BUS BAR LEFT B PHASE';
            case 'Ambient_Temperature_LT':
                if (this.filter.transformerId == "KR236-1350") {
                    return 'Breaker compartment-Ambient temp';
                }
                else {
                    return 'Ambient_Temperature_LT';
                }
            case 'Humidity_LT':
                if (this.filter.transformerId == "KR236-1350") {
                    return 'Breaker compartment-Humidity';
                }
                else {
                    return 'Humidity_LT';
                }
            case 'Ambient_Temperature_HT':
                if (this.filter.transformerId == "KR236-1350") {
                    return 'Cable Compartment-Ambient temp';
                }
                else {
                    return 'Ambient_Temperature_HT';
                }
            case 'Humidity_HT':
                if (this.filter.transformerId == "KR236-1350") {
                    return 'Cable Compartment-Humidity';
                }
                else {
                    return 'Humidity_HT';
                }
            case 'PRV_Status':
                if (this.filter.transformerId == "KR181-1295" || this.filter.transformerId == "KR182-1296") {
                    return 'Master Trip';
                }
                else {
                    return 'PRV_Status';
                }
            case 'OTI_Status':
                if (this.filter.transformerId == "KR181-1295" || this.filter.transformerId == "KR182-1296") {
                    return 'MOG OLTC';
                }
                else {
                    return 'OTI_Status';
                }
            default:
                return col;
        }
    };
    ReportComponent.prototype.DailyConsumptionReport = function () {
        var _this = this;
        this.ngxLoader.start();
        this.reportService.getDailyConsumptionReport(this.deviceID).toPromise().then(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var downloadURL;
            return tslib_1.__generator(this, function (_a) {
                if (response.type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                    downloadURL = window.URL.createObjectURL(response);
                    saveAs(downloadURL, 'Yesterdays_Consumption_Report');
                    this.ngxLoader.stop();
                }
                else {
                    this.toastr.warning("No data was found for yesterday.");
                    this.ngxLoader.stop();
                }
                return [2 /*return*/];
            });
        }); });
    };
    ReportComponent.prototype.onFolderSelect = function (event) {
        var files = Array.from(event.target.files);
        if (files.length > 0) {
            this.uploadFolder(files);
        }
    };
    ReportComponent.prototype.uploadFolder = function (files) {
        var _this = this;
        this.isUploading = true;
        this.reportService.uploadFolder(files).subscribe(function (response) {
            _this.isUploading = false;
            Swal.fire({
                icon: 'success',
                title: 'Success!',
                text: 'Your operation completed successfully!',
                confirmButtonText: 'OK'
            });
            console.log('Folder uploaded successfully:', response);
        }, function (error) {
            console.error('Error uploading folder:', error);
        });
    };
    ReportComponent.prototype.getUploadData = function () {
        var _this = this;
        this.isDownloading = true;
        this.reportService.getUploadData().subscribe(function (response) {
            if (response.code == 1) {
                _this.isDownloading = false;
                Swal.fire({
                    title: 'Success!',
                    text: 'Data updated successfully.',
                    icon: 'success',
                    timer: 1000,
                    showConfirmButton: false
                });
            }
            else {
                _this.isDownloading = false;
            }
        });
    };
    ReportComponent.prototype.onPageChange = function (event) {
        console.log("asdsa", event.pageIndex, this.pageIndex);
        if (event.pageIndex > this.pageIndex) {
            this.pageIndexNextCompare++;
            this.nextDataLoad(this.filter);
        }
        else {
            this.pageIndexNextCompare--;
        }
        this.pageIndex = event.pageIndex;
    };
    ReportComponent.prototype.downloadExcel = function (type) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                if (this.filter.filter == "Today" || this.filter.filter == "Yesterday") {
                    this.filter.startDate = this.filter.date;
                    this.filter.endDate = this.filter.date;
                }
                else {
                    Swal.fire({
                        icon: 'success',
                        title: 'Report Scheduled 📧',
                        html: "\n                  <p style=\"font-size:15px; margin-top:10px; color:#555;\">\n                    Your report file will be automatically sent to your \n                    <b>registered email</b> within the next <b>5 minutes</b>.\n                  </p>\n                  <p style=\"font-size:14px; color:#777; margin-top:8px;\">\n                    Thank you for your patience.\n                  </p>\n                ",
                        showConfirmButton: false,
                        timer: 5000,
                        timerProgressBar: true,
                        background: '#f9f9f9',
                        customClass: {
                            title: 'text-lg font-semibold text-gray-800',
                        }
                    });
                }
                this.reportService.excelDownload(this.filter).subscribe(function (res) {
                    if (_this.filter.filter == "Today" || _this.filter.filter == "Yesterday") {
                        var fileName = 'GatewayData.xlsx'; // fallback if backend doesn’t send filename
                        var blob = new Blob([res], { type: res.type || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        var url = window.URL.createObjectURL(blob);
                        var a = document.createElement('a');
                        a.href = url;
                        a.download = fileName;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        window.URL.revokeObjectURL(url);
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    // Sleep helper function
    ReportComponent.prototype.wait = function (ms) {
        return new Promise(function (resolve) { return setTimeout(resolve, ms); });
    };
    ReportComponent.prototype.exportToExcel = function (data, fileName) {
        this.downloadMessage = "Exporting Data to Excel";
        var MAX_ROWS = 104857602;
        var MAX_COLS = 16384;
        var header = this.reportColumns;
        // SAFEGUARD: Filter out invalid rows
        var cleanedRows = data
            .filter(function (row) { return typeof row === 'object' && row !== null; })
            .map(function (row) {
            return header.map(function (col) {
                var val = row[col];
                return val === undefined || val === null ? '' : val;
            });
        });
        var sheetData = [header].concat(cleanedRows);
        // Extra logging to catch structural issues
        if (!Array.isArray(sheetData) || !Array.isArray(sheetData[0])) {
            console.error("🚫 sheetData structure is invalid", sheetData);
            //alert("Export failed: Invalid sheet data structure.");
            return;
        }
        if (sheetData.length > MAX_ROWS || header.length > MAX_COLS) {
            console.error("❌ Excel limits exceeded");
            //alert(`Data too large. Max allowed: ${MAX_ROWS} rows, ${MAX_COLS} columns.`);
            return;
        }
        try {
            var worksheet = XLSX.utils.aoa_to_sheet(sheetData);
            worksheet['!cols'] = header.map(function (col) { return ({
                wch: (col && col.length) ? (col.length + 5) : 10
            }); });
            var range = XLSX.utils.decode_range(worksheet['!ref']);
            for (var R = range.s.r; R <= range.e.r; ++R) {
                for (var C = range.s.c; C <= range.e.c; ++C) {
                    var cellRef = XLSX.utils.encode_cell({ r: R, c: C });
                    var cell = worksheet[cellRef];
                    if (cell) {
                        cell.s = {
                            alignment: { horizontal: 'center', vertical: 'center' },
                            border: {
                                top: { style: 'thin', color: { rgb: '000000' } },
                                bottom: { style: 'thin', color: { rgb: '000000' } },
                                left: { style: 'thin', color: { rgb: '000000' } },
                                right: { style: 'thin', color: { rgb: '000000' } }
                            },
                            font: R === 0 ? { bold: true } : {}
                        };
                    }
                }
            }
            var workbook = {
                SheetNames: ['Sheet1'],
                Sheets: {
                    Sheet1: worksheet
                }
            };
            var excelBuffer = XLSX.write(workbook, {
                bookType: 'xlsx',
                type: 'array'
            });
            var blob = new Blob([excelBuffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
            });
            FileSaver.saveAs(blob, fileName + ".xlsx");
        }
        catch (err) {
            console.error("❌ Excel write error:", err);
            //alert("❌ Failed to export Excel. Please check console for details.");
        }
    };
    ReportComponent.prototype.downloadloraReport = function () {
        this.reportService.downloadLoraReport().subscribe({
            next: function (res) {
                var blob = new Blob([res], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });
                var url = window.URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.href = url;
                a.download = "Fibix_Report_" + new Date().getTime() + ".xlsx";
                document.body.appendChild(a);
                a.click();
                // cleanup
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            },
            error: function (err) {
                console.error('Download error', err);
            }
        });
    };
    return ReportComponent;
}());
export { ReportComponent };
